var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-product-size"},[(_vm.loading && Object.keys(_vm.productView).length == 0)?[_c('PuSkeleton',{attrs:{"count":3}})]:[_c('variant-size')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }